import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
const Container = styled.svg.withConfig({
  displayName: "LoadingSpinner__Container",
  componentId: "sc-1elzxzk-0"
})(["animation:rotate 2s linear infinite;margin:0px;width:", ";height:", ";& .path{stroke-linecap:round;animation:dash 1.5s ease-in-out infinite;}@keyframes rotate{100%{transform:rotate(360deg);}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0;}50%{stroke-dasharray:90,150;stroke-dashoffset:-35;}100%{stroke-dasharray:90,150;stroke-dashoffset:-124;}}"], props => props.size, props => props.size);
export const LoadingSpinner = observer(() => {
  return /*#__PURE__*/React.createElement(Container, {
    viewBox: "0 0 50 50",
    size: "30px"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "4",
    stroke: UiConstants.COLOR_SELECTION_HIGHLIGHT
  }));
});
export const LoadingSpinnerBlack = observer(() => {
  return /*#__PURE__*/React.createElement(Container, {
    viewBox: "0 0 50 50",
    size: "30px"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "4",
    stroke: "black"
  }));
});
export const LoadingSpinnerSmall = observer(() => {
  return /*#__PURE__*/React.createElement(Container, {
    viewBox: "0 0 50 50",
    size: "16px"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "path",
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    strokeWidth: "4",
    stroke: "black"
  }));
});